const language = localStorage.getItem('language') || 'zh-CN';

const isZH = language === 'zh-CN';

export default [
  isZH
    ? {
        label: '动态',
        key: '/discover',
      }
    : undefined,
  {
    label: 'OKR',
    key: '/okr',
  },
  isZH
    ? {
        label: 'OKR进展',
        key: '/process/list',
      }
    : undefined,
  isZH
    ? {
        label: '设置',
        key: '/setting',
        needAuth: true,
        role: ['seeReport', 'deptAdmin'],
        children: [
          {
            label: 'OKR看板',
            key: '/setting/view-panel',
            needAuth: true,
            role: ['deptAdmin'],
          },
          {
            label: 'OKR报表',
            key: '/setting/report',
            needAuth: true,
            role: ['seeReport', 'deptAdmin'],
          },
          {
            label: '共享设置',
            key: '/setting/share',
            needAuth: true,
            role: ['deptAdmin'],
          },
          {
            label: '周期设置',
            key: '/setting/period',
            needAuth: true,
            role: ['deptAdmin'],
          },
          {
            label: '运维工具',
            key: '/setting/operation',
            needAuth: true,
            role: ['superAdmin'],
          },
        ],
      }
    : undefined,
].filter(Boolean);
